var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCalendar3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.73077 0.5C4.02815 0.5 4.26923 0.741077 4.26923 1.03846V2.11538H10.7308V1.03846C10.7308 0.741077 10.9718 0.5 11.2692 0.5C11.5666 0.5 11.8077 0.741077 11.8077 1.03846V2.11538H12.3462C13.5357 2.11538 14.5 3.07969 14.5 4.26923V12.3462C14.5 13.5357 13.5357 14.5 12.3462 14.5H2.65385C1.46431 14.5 0.5 13.5357 0.5 12.3462V4.26923C0.5 3.07969 1.46431 2.11538 2.65385 2.11538H3.19231V1.03846C3.19231 0.741077 3.43339 0.5 3.73077 0.5ZM13.4231 6.96154C13.4231 6.36677 12.9409 5.88462 12.3462 5.88462H2.65385C2.05908 5.88462 1.57692 6.36677 1.57692 6.96154V12.3462C1.57692 12.9409 2.05908 13.4231 2.65385 13.4231H12.3462C12.9409 13.4231 13.4231 12.9409 13.4231 12.3462V6.96154Z",
    fill: "#0F172A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCalendar3);
export default __webpack_public_path__ + "static/media/ic-calendar3.84171eeda5c733ee9be1d17ed1246042.svg";
export { ForwardRef as ReactComponent };